import {Component, ViewChild} from '@angular/core'
import {Router, NavigationEnd} from '@angular/router'
import {UserService} from './user/user.service'
import {FolderService} from './folder/folder.service'
import {BrandService} from './brand'
import {environment} from '../environments/environment'
import * as smoothscroll from 'smoothscroll-polyfill'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [BrandService],
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'app'
  adblock = true
  date = new Date()
  env = environment

  @ViewChild('main') main

  constructor(
    private router: Router,
    public user: UserService,
    public folder: FolderService,
    public brandService: BrandService
  ) {
    smoothscroll.polyfill()

    // Google Analytics routing events
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ;(<any>window).ga('set', 'page', event.urlAfterRedirects)
        ;(<any>window).ga('send', 'pageview')

        setTimeout(e => {
          if (window.scrollY > this.main.nativeElement.offsetTop)
            window.scrollTo({
              top: this.main.nativeElement.offsetTop,
              left: 0,
              behavior: 'smooth',
            })
        }, 0)
      }
    })

    if (document.getElementById('XrwblOQiauAg')) {
      this.adblock = false
    } else {
      this.adblock = true
      console.warn(
        "Ad blocking detected. If you're trying to figure out why a banner doesn't work, this might be it."
      )
    }
  }

  isBannerboy() {
    return (
      this.user.current && this.user.current.email.includes('@bannerboy.com')
    )
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/app.component.ts